// This logic is copied from  wix-design-systems-locale-utils
// Cannot be used as dependency since it weights too much
export const SupportedWixLocales = [
    'en',
    'en-US',
    'en-GB',
    'en-AU',
    'en-CA',
    'ar',
    'bg',
    'ca',
    'zh',
    'zh-TW',
    'zh-HK',
    'zh-MO',
    'cs',
    'da',
    'nl',
    'fi',
    'fr',
    'fr-CA',
    'fr-CH',
    'fr-BE',
    'de',
    'de-CH',
    'de-AT',
    'el',
    'he',
    'hi',
    'hu',
    'id',
    'it',
    'ja',
    'ko',
    'lt',
    'ms',
    'no',
    'nb',
    'nn',
    'pl',
    'pt-BR',
    'pt',
    'ro',
    'ru',
    'sk',
    'sl',
    'es',
    'es-419',
    'es-AR',
    'es-MX',
    'es-US',
    'sv',
    'tl',
    'th',
    'tr',
    'uk',
    'vi'
];
const splitDate = (locale, date, format = {})=>{
    const { year = 'numeric', month = 'numeric', day = 'numeric' } = format;
    return {
        year: new Intl.DateTimeFormat(locale, {
            year
        }).format(date),
        month: new Intl.DateTimeFormat(locale, {
            month
        }).format(date),
        day: new Intl.DateTimeFormat(locale, {
            day
        }).format(date)
    };
};
const modifiedShortDates = {
    fi: (date)=>{
        const { day, month, year } = splitDate('fi', date);
        return `${day}.${month}.${year}`;
    },
    ko: (date)=>{
        const { day, month, year } = splitDate('ko', date, {
            month: '2-digit',
            day: '2-digit'
        });
        return `${year}.${month}.${day}`.replace(/년|월|일/g, '');
    },
    sk: (date)=>new Intl.DateTimeFormat('sk').format(date).replace(/ /g, ''),
    nn: (date)=>new Intl.DateTimeFormat('nn').format(date).replace(/\//g, '.'),
    'es-US': (date)=>{
        const { day, month, year } = splitDate('es-US', date);
        return `${month}/${day}/${year}`;
    },
    sv: (date)=>{
        const { day, month, year } = splitDate('sv', date);
        return `${day}/${month} ${year}`;
    }
};
/**
 * Function that returns short date format approved by Wix Localization team.
 * @param locale - language/country short value that is passed to Intl.DateTimeFormat
 * @param date - JavaScript Date objects represent a single moment in time in a platform-independent format.
 */ export const getShortDate = (locale, date)=>{
    if (modifiedShortDates[locale]) {
        return modifiedShortDates[locale]?.(date);
    }
    return new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(date);
};

//# sourceMappingURL=wix-design-systems-locale-utils.js.map